import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { authContext } from '../context/index.js';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { userData, loading } = useContext(authContext);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!userData) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && userData.role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
